import { Box, Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useBulkImportSupplements } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import {
  SHOW_MANAGED_IMPORTED_MODAL,
  SHOW_UPLOAD_MODAL,
} from 'modules/payroll_bundle/lib/constants'

interface Props {
  disabled?: boolean
  didImportSupplements?: boolean
  tooltipMessage?: string
}

export const BulkImportSplitButton = ({
  disabled,
  didImportSupplements,
  tooltipMessage,
}: Props) => {
  const { supplementDispatch } = useBulkImportSupplements()
  const [tooltipOpen, toggleTooltipOpen] = useToggle()

  const startImportProcess = () => {
    supplementDispatch({
      type: SHOW_UPLOAD_MODAL,
    })

    track(trackingEvents.payroll.userClicksOnPayrollImportSupplements)
  }

  const showManageImportedModal = () => {
    supplementDispatch({
      type: SHOW_MANAGED_IMPORTED_MODAL,
    })
  }

  const buttons = (
    <Button.Split
      type="secondary"
      label={i18n.t('payroll_bundle.import_supplements.import.import_supplements')}
      onClick={startImportProcess}
      disabled={disabled}
      optionsDisabled={disabled}
      dropdownAriaLabel={i18n.t('payroll_bundle.import_supplements.secondary_actions')}
    >
      <Button.Split.Option onClick={showManageImportedModal} disabled={!didImportSupplements}>
        {i18n.t('payroll_bundle.manage_imported_supplements.title')}
      </Button.Split.Option>
    </Button.Split>
  )

  return (
    <Box position="relative">
      {tooltipMessage ? (
        <Tooltip.Alt
          attachment="bottom center"
          label={tooltipMessage}
          open={tooltipOpen}
          toggle={toggleTooltipOpen}
        >
          {buttons}
        </Tooltip.Alt>
      ) : (
        buttons
      )}
    </Box>
  )
}
